import axios from 'axios';
import { getApiEndpoint } from './utilities';

export default {

    getConfiguration(cb) {
        axios.get('/umbraco/api/restaurant/getConfiguration')
            .then(response => {
                cb(response.data);
            });
    },

    getAvailability(payload, cb) {

        axios.post(getApiEndpoint() + 'api/restaurant', payload)
            .then(response => {
                cb(response.data);
            });
    }
}